export const translationNavigation_en_part3 = {
  currentProfilePicture: "Current profile picture",
  profilePictureDescription: "This will appear next to your messages in the chat",
  uploadNewProfilePicture: "Upload New Profile Picture",
  chooseFile: "Choose File",
  uploading: "Uploading...",
  supportedFormats: "Supported formats: JPEG, PNG, GIF, WebP. Max size: 5MB",
  saving: "Saving...",
  profilePictureUpdatedSuccess: "Profile picture updated successfully!",
  errorUploadingProfilePicture: "Error uploading profile picture. Please try again.",
  invalidFileType: "Please select a valid image file (JPEG, PNG, GIF, or WebP)",
  fileSizeError: "File size must be less than 5MB",
  notificationSettings: "Notification Settings",
  emailNotificationsLabel: "Email notifications",
  emailWhenTagged: "Email me when tagged in a report",
  livechatNotificationsLabel: "Live chat notifications",
  livechatPopupSetting: "Show a pop-up when there is new live chat activity",
  livechatOtherAgentsSetting: "Notify me about chats handled by other agents",
  notificationSoundTitle: "Notification Sound",
  notificationSoundDescription: "Play a sound when you receive new livechat messages",
  testNotificationSound: "Test Sound",
  testSoundEnabled: "Click to test the notification sound",
  testSoundDisabled: "Enable sound notifications to test",
  userProfilePicturesTitle: "User Profile Pictures",
  showUserProfilePicturesTitle: "Show User Profile Pictures",
  showUserProfilePicturesDescription:
    "Display animal avatar profile pictures for users in livechat conversations to help identify and remember users",

  // User edit chatbot editor — tab bar

  // User edit chatbot editor — tab bar
  userEditTabPreview: "Preview",
  userEditTabBasic: "Basic Settings",
  userEditTabProducts: "Products",
  userEditTabExtra: "Extra Settings",
  userEditTabMain: "Main Flow",
  userEditTabRouting: "Routing Flow",
  userEditTabStatistics: "Statistics Flow",
  userEditTabSuggestion: "Suggestion Flow",
  userEditTabApivar: "API Var Flow",
  userEditTabMetaPrefix: "Meta: ",
  userEditTabDomainRestrictions: "Domain Restrictions",
  userEditTabImage: "Image Flow",
  userEditTabShopify: "Shopify",
  userEditTabMagento: "Magento",
  userEditTabShipmondo: "Shipmondo",
  userEditTabCommerceTools: "CommerceTools",
  userEditTabUniversalApiPlanner: "Universal API Planner",
  userEditTabUniversalApi: "Universal API Integration",
  userEditUniversalApiPlannerStepLimitsTitle: "Planner steps (minimum / maximum)",
  userEditUniversalApiPlannerStepLimitsHint:
    'Minimum is how many planner rounds must run before a "finish" decision is honored. Maximum caps planner calls per message (1–10). Save limits separately from integration credentials.',
  userEditUniversalApiPlannerMinSteps: "Minimum steps",
  userEditUniversalApiPlannerMaxSteps: "Maximum steps",
  userEditUniversalApiPlannerSaveStepLimits: "Save planner limits",
  userEditUniversalApiPlannerSavingStepLimits: "Saving…",

  userEditBasicSettingsSectionTitle: "Basic Settings",
  userEditNoKnowledgeBaseIndexesHint:
    "No knowledge base indexes configured. Add them in Basic Settings.",
};
